export default "__VITE_ASSET__CAQo24xv__"